<template>
 <v-container fluid ma-0 pa-0 px-4 id="bucketedit-main">
    <Loading :isLoading="loading">
      <div class="fixed-header" :class="{'mobile': $vuetify.breakpoint.smAndDown}"><!-- if has summary fields add class 'with-summary' -->
        <v-layout  align-center fill-height class="fixed-header-wrapper">
          <v-flex shrink class="text-truncate" pr-4>
            <v-tooltip color="secondary" bottom>
              <template v-slot:activator="{ on }">
                <h2 v-on="on" class="p-relative text-truncate" >
                  {{bucketName}}
                </h2>
              </template>
                <span>{{bucketName}}</span>
              </v-tooltip>
            <h4 class="pt-1 sub-header ">Configure your bucket</h4>
          </v-flex>
          <v-spacer></v-spacer>
        </v-layout>
      </div>
      <v-container pa-0 mt-4 fluid class="elevation-2 rounded-3" style="background-color:white">
        <v-flex>
          <v-tabs id="bucketedit-tabs" grow slider-color="primary" v-if="!currentUserLoading">
            <template v-for="item in items">
              <v-tab ripple :key="item.component">{{ item.name }}</v-tab>
              <v-tab-item :key="item.name">
                <v-divider></v-divider>
                <v-container fluid>
                  <v-layout row wrap>
                    <v-flex xs12 px-4 pt-3 pb-1 mb-0>
                      <component
                        :is="item.component"
                        v-on:bucket-update="changesMade=true"
                        :bucket="bucket"
                        :caseType="caseType"
                        :schema="currentSchema"/>
                    </v-flex>
                  </v-layout>
                </v-container>
              </v-tab-item>
            </template>
          </v-tabs>
        </v-flex>
      </v-container>

      <v-layout row fluid wrap>
        <div class="mt-3">
          <DeleteBucketDialog @deleteBucket="deleteBucket"></DeleteBucketDialog>
        </div>
        <v-spacer></v-spacer>
        <v-btn
          @click="cancelEdit()"
          class="mt-4 ml-0"
          color="secondary"
          id="bucketedit-back-btn">
          Back
        </v-btn>
        <v-btn
          @click="updateBucket(true)"
          class="mt-4 ml-0"
          color="success"
          id="bucketedit-save-btn">
          Save Changes
        </v-btn>
      </v-layout>
    </Loading>
  </v-container>
</template>

<script>
import Vue from "vue"
import "@/assets/styles/styles.css"
import { mapState } from "vuex"
import BucketAdvancedTab from "@/components/buckets/bucket-edit/Tabs/BucketAdvancedTab.vue"
import BucketDetailsTab from "@/components/buckets/bucket-edit/Tabs/BucketDetailsTab.vue"
import BucketFieldsTab from "@/components/buckets/bucket-edit/Tabs/BucketFieldsTab.vue"
import BucketFiltersTab from "@/components/buckets/bucket-edit/Tabs/BucketFiltersTab.vue"
import BucketBoardViewTab from "@/components/buckets/bucket-edit/Tabs/BucketBoardViewTab.vue"
import DeleteBucketDialog from "@/components/buckets/bucket-elements/DeleteBucketDialog"
import Loading from "@/components/shared/Loading.vue"

export default {
  name: "bucket-edit",
  components: {
    BucketAdvancedTab,
    BucketDetailsTab,
    BucketFieldsTab,
    BucketFiltersTab,
    DeleteBucketDialog,
    BucketBoardViewTab,
    Loading
  },
  data: () => ({
    data: { icon: "archive" },
    changesMade: false,
    loading: false,
    showSaveBucketDialog: "",
    showDeleteBucketDialog: "",
    items: [
      { name: "Summary", title: "Summary", component: "BucketDetailsTab" },
      { name: "Fields", title: "Displayed Fields", component: "BucketFieldsTab" },
      { name: "Filters", title: "Filters", component: "BucketFiltersTab" },
      { name: "Advanced", title: "Advanced", component: "BucketAdvancedTab" }
    ],
    selected: { name: "Summary", title: "Summary", component: "BucketDetailsTab" }
  }),
  watch: {
    selected() {
      this.checkSaveDialog()
    },
    currentUserLoading() {
      this.loadData()
    }
  },
  computed: {
    ...mapState({
      bucket: state => state.buckets.current.bucket,
      caseType: state => state.caseTypes.current,
      bucketName: state =>
        state &&
        state.buckets &&
        state.buckets.current.bucket &&
        state.buckets.current.bucket.name
          ? state.buckets.current.bucket.name
          : "",
      bucketCaseType: state =>
        state &&
        state.buckets &&
        state.buckets.current.bucket &&
        state.buckets.current.bucket.caseTypeName
          ? state.buckets.current.bucket.caseTypeName
          : "",
      currentUser: state => state.currentUser,
      currentUserLoading: state => state.currentUser.isCurrentUserLoading
    }),
    currentSchema() {
      const fieldsets = [{ name: "common", fields: [{ name: "title" }, { name: "current_state" }, { name: "created_at" }, { name: "updated_at" }, { name: "last_exported_at" }, { name: "last_exported_via_bucket_id" }, { name: "sentiment_score" }, { name: "sentiment_magnitude" }, { name: "no_unread_conversations" }, { name: "unresolved_task_failures" }] }]

      for (const fs of this.caseType.currentSchema.fieldsets) {
        fieldsets.push(
          { name: fs.name, fields: fs.fields.map(f => ({ name: f.name })) }
        )
      }
      return { fieldsets }
    }
  },
  methods: {
    async loadData() {
      // await this.$store.dispatch("findBucket", this.$route.params.bucket_id);
      // await this.$store.dispatch("setSchema", this.$route.params.case_type_id);
      await this.$store.dispatch("mapSortFieldsToDisplayFields")
    },
    deletableBucket() {
      if (this.loading) return false
      const bucketOwned = this.ownedByUser || this.ownedByTeam
      return !(this.bucket.default && !bucketOwned)
    },
    ownedByUser() {
      return (
        this.bucket.ownedByType === "CaseBlocks::User" &&
        this.bucket.ownedById === this.currentUser.id
      )
    },
    ownedByTeam() {
      const teamIds = this.currentUser.account.teams.map(team => team.id)
      return (
        this.bucket.ownedByType === "CaseBlocks::Team" &&
        teamIds.includes(this.bucket.ownedById)
      )
    },
    checkSaveDialog() {
      this.showSaveBucketDialog = this.changesMade
    },
    deleteBucket() {
      this.$store.dispatch("deleteBucket", this.bucket.id)
      Vue.router.push({ name: "CaseTemplateOverview", params: { case_type_id: this.caseType.id } })
    },
    updateBucket() {
      this.changesMade = false
      this.showSaveBucketDialog = false
      this.$store.dispatch("updateBucket", this.bucket)
    },
    cancelEdit() {
      Vue.router.push({ name: "Bucket", params: { case_type_id: this.caseType.id, bucket_id: this.bucket.id } })
    }
  }
}
</script>
